import React from 'react';
import { compose } from 'recompose';
import { Table } from 'reactstrap';
import {
  TableContainer,
  Pagination,
  TableDataFetch,
  withTable,
  TableSearch,
  EditDeleteButtons,
  ViewingRecords,
} from 'components/common/Tables/index';
import Page from '../../components/common/Page';

export const InstallerRuleList = ({
  selected,
  match,
  url = 'installer-rules',
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  setOffset,
  search,
  setSearch,
  isDeleteModalOpen,
  toggleDeleteModal,
  onDeleteItem,
  onDeleted,
  refreshToken,
  readOnly,
}) => (
  <Page title="Installer Rules">
    <TableSearch onChange={setSearch} value={search} />
    <TableContainer
      items={data.results}
      ordering={ordering}
      onOrderingChanged={setOrdering}
      selected={selected}
      onSelectedChanged={setSelected}
    >
      <Table>
        <thead>
          <tr>
            <th sortBy="name">Country</th>
            <th>Primary Installer</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.results.map(i => (
            <tr key={i.id}>
              <td>{i.name}</td>
              <td>
                {i.primary_installer ? i.primary_installer.name : 'Not Set'}
              </td>
              <td className="text-right">
                <EditDeleteButtons
                  url={match.url}
                  id={i.id}
                  readOnly={readOnly}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    <TableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
    />
    <ViewingRecords
      offset={offset}
      limit={limit}
      count={data.count}
      className="float-left"
    />
    <div className="float-right">
      <Pagination
        size="sm"
        count={data.count}
        limit={limit}
        offset={offset}
        onOffsetChanged={setOffset}
      />
    </div>
  </Page>
);

const enhance = compose(withTable({ limit: 25 }));

export default enhance(InstallerRuleList);



// WEBPACK FOOTER //
// ./src/pages/InstallerRules/List.jsx